/* ============================================================
   Heideman · Summer Box (Athen Edition)
   - Scroll-triggered fade-in via IntersectionObserver
   - Gold / Silber variant toggle (synced across .vt-opt and .color-opt)
   - Hover-preview on .vt-opt
   ============================================================ */
(function(){
  if (typeof document === 'undefined') return;

  function init(){
    // Scope to the Summer Box wrapper(s). If none exist on this page, bail.
    var roots = document.querySelectorAll('.tsb');
    if (!roots.length) return;

    /* ----- Fade-up observer ----- */
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) {
            e.target.classList.add('in');
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.12 });

      roots.forEach(function(root){
        root.querySelectorAll('.fade-up').forEach(function(el){ obs.observe(el); });
      });
    } else {
      // No IO support — reveal immediately
      roots.forEach(function(root){
        root.querySelectorAll('.fade-up').forEach(function(el){ el.classList.add('in'); });
      });
    }

    /* ----- Color / Variant toggle (Gold / Silber) ----- */
    function colorOf(btn){
      if (btn.dataset && btn.dataset.color) return btn.dataset.color;
      var t = (btn.textContent || '').trim().toLowerCase();
      return t.indexOf('silber') !== -1 || t.indexOf('silver') !== -1 ? 'silver' : 'gold';
    }

    roots.forEach(function(root){
      var toggles = root.querySelectorAll('.color-opt, .vt-opt');
      if (!toggles.length) return;

      function setMode(color){
        if (color === 'silver') root.classList.add('silver-mode');
        else root.classList.remove('silver-mode');
        toggles.forEach(function(b){
          if (colorOf(b) === color) b.classList.add('active');
          else b.classList.remove('active');
        });
      }

      toggles.forEach(function(btn){
        var color = colorOf(btn);
        btn.addEventListener('click', function(){ setMode(color); });
        btn.addEventListener('mouseenter', function(){
          root.classList.remove('preview-gold','preview-silver');
          root.classList.add('preview-' + color);
        });
        btn.addEventListener('mouseleave', function(){
          root.classList.remove('preview-gold','preview-silver');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
